import { SET_ACCOUNT } from '../actions/types';

export default function account(state = null, action) {
	if (!action.error && action.payload && action.type === SET_ACCOUNT) {
		return action.payload;
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/account.js